import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const RutaPrivada = ({ children }) => {
  const { adminAuth } = useAuth();

  return adminAuth ? children : <Navigate to="/login" replace />;
};

export default RutaPrivada;
